import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { MediaAsset, OrgAssets } from '../../views'
import { orgAssetsAtom } from '../state'

export type UseEditorOrgAssetsArguments = {
	orgAssets?: OrgAssets
	onUpload: (files: FileList, collection: MediaAsset['collection']) => void
}

export type UseEditorOrgAssetsReturns = {
	onUpload: (files: FileList, collection: MediaAsset['collection']) => void
}

export function useEditorOrgAssets(args: UseEditorOrgAssetsArguments): UseEditorOrgAssetsReturns {
	const { orgAssets, onUpload } = args
	const setOrgAssets = useSetAtom(orgAssetsAtom)

	// Update org assets when data changes
	useEffect(() => {
		if (orgAssets) {
			setOrgAssets(orgAssets)
		}
	}, [orgAssets, setOrgAssets])

	return {
		onUpload,
	}
}
